module.exports = __webpack_public_path__ + "static/media/vk.0c0fe75c.webp";